// Les options (features_v2) et la tarification par défaut d'un nouveau client
// sont servies par l'API (GET /super-admin/clients/defaults), seule source de
// vérité. Les features v1 ne sont plus gérées.

export const EMPTY_CLIENT_INFORMATION = {
  name: '',
  siret: '',
  tva: '',
  street: '',
  zipcode: '',
  city: '',
  country: 'France',
  is_email_sending_enabled: true,
  is_sms_sending_enabled: true,
};

export const EMPTY_FACTORY = {
  name: '',
  street: '',
  zipcode: '',
  city: '',
  latitude: '',
  longitude: '',
};

export const DOCUMENT_TEMPLATE_TYPES = {
  DELIVERY_NOTE: 'DELIVERY_NOTE',
  DRIVER_LETTER: 'DRIVER_LETTER',
  TOUR_SUMMARY: 'TOUR_SUMMARY',
  OTHER: 'OTHER',
  properties: {
    DELIVERY_NOTE: { display_name: 'Bon de livraison' },
    DRIVER_LETTER: { display_name: 'Lettre de voiture' },
    TOUR_SUMMARY: { display_name: 'Récapitulatif de tournée' },
    OTHER: { display_name: 'Autre' },
  },
};

// Doivent rester alignés sur super-admin-clients.middleware.ts côté fleet-api.
export const LOGO_ACCEPTED_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.svg',
  '.webp',
];
export const LOGO_MAX_SIZE_MB = 2;
export const TEMPLATE_ACCEPTED_EXTENSIONS = [
  '.html',
  '.htm',
  '.pdf',
  '.docx',
  '.odt',
];
export const TEMPLATE_MAX_SIZE_MB = 10;
